import React, { Component } from "react";
import classnames from "classnames";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { IRtcStream } from "@formant/core/model/IRtcStream";
import { IRtcStreamMessage } from "@formant/rtc-client/models/IRtcStreamMessage";

import { ITeleopSession } from "../../../teleop/ITeleopSession";
import * as styles from "./StatusItem.scss";

export interface IStatusItemProps {
    session: ITeleopSession;
    stream: IRtcStream;
}

@observer
export class StatusItem extends Component<IStatusItemProps> {
    private unregister?: () => boolean;

    @observable
    private value = false;

    public componentDidMount() {
        this.unregister = this.props.session.registerReceiver(
            this.props.stream.streamName,
            this.onReceiveBoolean,
        );
    }

    public componentWillUnmount() {
        if (this.unregister) {
            this.unregister();
        }
    }

    public render() {
        const { stream } = this.props;
        const { value } = this;

        return (
            <div
                className={classnames(
                    styles["status-item"],
                    value && styles.on,
                )}
            >
                <div className={styles.indicator} />
                <div className={styles.label}>
                    {stream.label || stream.streamName}
                </div>
            </div>
        );
    }

    private onReceiveBoolean = (msg: IRtcStreamMessage) => {
        const { stream } = this.props;
        if (msg.payload.boolean !== undefined) {
            this.value = msg.payload.boolean;
        }
        if (msg.payload.bitset !== undefined && stream.label) {
            const bit = msg.payload.bitset.bits.find(
                _ => _.key === stream.label,
            );
            if (bit) {
                this.value = bit.value;
            }
        }
    };
}
